import { ref } from 'constants/firebase'
import { receiveUser } from 'actions/userAC'
import { receiveApps } from 'actions/appsAC'
import _ from 'lodash'
import { displaySuccess } from '../components/NotificationController'
import co from 'co'
import migrations from './migrations'
import { getABTestingGroup } from 'utils/utils'
import { gotoChargeDeclinedPage } from './shopifyApp'
let listener

const USER_VERSION = 1

function * migrate (user) {
  const curVersion = _.get(user, 'version', 0)
  if (curVersion < USER_VERSION) {
    for (let n = curVersion; n < USER_VERSION; n++) {
      const f = migrations[n]
      f(user)
    }
    user.version = USER_VERSION
    _.unset(user, 'createdAt')
    yield ref.child('users').child(user.id).update(user)
  }
}

function * userReceived (user, dispatch) {
  console.log('user received', user)
  if (user) {
    yield migrate(user)
    if (user.apps) {
      // console.log('dispatch receive apps', user.apps)
      dispatch(receiveApps(user.apps))
    }
    // console.log('dispatch receive user', user)
    _.unset(user, 'apps')
    if (!user.testGroup) {
      user.testGroup = getABTestingGroup(user.id)
      console.log('mixpanel register group for user')
      mixpanel.register({ //eslint-disable-line no-undef
        testGroup: user.testGroup
      })
    }
    dispatch(receiveUser(user))
    if (user.status === 'declined') {
      gotoChargeDeclinedPage(user.id)
    }
  }
}

export function fetchUser (userId) {
  return function * (dispatch) {
    console.log('fetch user', userId)
    try {
      if (_.isNil(listener)) {
        const l = ref.child('users').child(userId).on('value', userSN => {
          // console.log('user record changed')
          const user = userSN.val()
          co(userReceived(user, dispatch))
        })
        listener = l
      } else {
        // console.log('fetchUser', userId, 'listener already exists')
      }
    } catch (e) {
      console.error('fetchUser error', e)
    }
  }
}

export function cancelUserListener () {
  if (listener) {
    ref.off('value', listener)
  }
  listener = null
}

export function saveUserAttributes (userId, fullName, companyName, email = null) {
  return function * (dispatch) {
    const data = {
      fullName,
      companyName
    }
    if (!_.isNil(email)) data.email = email
    yield ref.child('users').child(userId).update(data)
    displaySuccess('Account settings saved')
  }
}



// WEBPACK FOOTER //
// ./src/controllers/user.js